import { render, staticRenderFns } from "./NotificationListCatalog.vue?vue&type=template&id=b16d0232&scoped=true"
import script from "./NotificationListCatalog.vue?vue&type=script&lang=js"
export * from "./NotificationListCatalog.vue?vue&type=script&lang=js"
import style0 from "./NotificationListCatalog.vue?vue&type=style&index=0&id=b16d0232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16d0232",
  null
  
)

export default component.exports